
import {
  getFullRouteWithQueryString,
  getRouteWithQueryString,
} from "../services/commonMethods";

//Routes of the application.
export const APP_ROUTES = {
  HOME: "/",
  DASHBOARD: "/dashboard",
  ORDERS: "/orders",
  CUSTOMER_FEEDBACK_LIST: "/customer-feedbacks",
  MASTER_DATA_SETUP: "/master-data-setup",
  REQUEST_PRODUCTS_LIST: "/request-products",
  PRODUCT_CATALOG: "/products",
  PRODUCT_CATEGORY_LIST: "/product-categories",
  PRODUCT_BRAND_LIST: "/product-brands",
  PRODUCT_UNIT_LIST: "/product-units",
  PRODUCT_PACKAGING_LIST: "/product-packagings",
  SYNC_PRODUCT_LIST: "/sync-products",
  NEW_PRODUCT_LIST: "/new-product-list",
  CREATE_VENDING_MACHINE: "/configure-vm",
  TECH_CREATE_VENDING_MACHINE: "/tech-configure-vm",
  EDIT_VENDING_MACHINE: "/reconfigure/:id",
  TECH_EDIT_VENDING_MACHINE: "/tech-reconfigure/:id",
  VENDING_MACHINE_MASTER_CONFIG: "/master-config/:id",
  VIEW_ZONE: "/zone/:id",
  VIEW_WAREHOUSE: "/warehouse/:id",
  WAREHOUSES_LIST: "/warehouses",
  STORES_LIST: "/stores",
  LIST_REFILLS: "/refills",
  ADD_REFILL_PLAN: "/add-refill-plan",
  EDIT_REFILL_PLAN: "/edit-refill-plan",
  // RETURN_ORDER_VIEW: "/return-order-view/:id",
  RETURN_ORDER_VIEW: "/return-order-view",
  VIEW_REFILL_PLAN: "/view-refill-plan",
  LIST_VENDING_MACHINES: "/vm",
  CHANGE_PLANOGRAM_FOR_MULTIPLE_VMs: "/change-planogram-multiple-vm",
  SALES_ANALYTICS: "/sales-analytics",
  SUPPLIER_LIST: "/suppliers",
  SUPPLIER_VIEW: "/supplier/:id",
  SUPPLIER_EDIT: "/edit-supplier/:id",
  SUPPLIER_ADD: "/add-supplier",
  SUPPLIER_RETURN_OVERVIEW: "/supplier-return-overview/:id",
  MATERIAL_TRANSFER_OVERVIEW: "/material-transfer-overview/:id",
  MATERIAL_TRANSFER_MANAGE: "/material-transfer/manage/:id",
  MATERIAL_TRANSFER_EDIT: "/edit-material-transfer/:id",
  TALLY_INVENTORY_OVERVIEW: "/tally-inventory-overview/:id",
  PRODUCT_VIEW: "/product/:id",
  PRODUCT_CATEGORY_VIEW: "/product-category/:id",
  PURCHASE_ORDER_LIST: "/purchase-orders",
  WAREHOUSE_ORDER_LIST: "/warehouse-orders",
  WAREHOUSE_STOCK: "/warehouse-stock/:id",
  PURCHASE_ORDER_ADD: "/add-purchase-order",
  PURCHASE_ORDER_EDIT: "/edit-purchase-order/:id",
  SAME_PURCHASE_ORDER: "/same-purchase-order/:id",
  PURCHASE_ORDER_VIEW: "/purchase-order/:id",
  PURCHASE_RETURN_EDIT: "/edit-purchase-return/:id",
  PURCHASE_RETURN_ADD: "/add-purchase-return",
  PURCHASE_ORDER_RETURN: "/purchase-order-return",
  PURCHASE_RETURN_VIEW: "/purchase-return/:id",
  PURCHASE_ORDER_MANAGE: "/purchase-order/manage/:id",
  TALLY_INVENTORY_ADD: "/add-tally-inventory/:id",
  TALLY_INVENTORY_EDIT: "/edit-tally-inventory/:id",
  TALLY_INVENTORY_VIEW: "/tally-inventory/:id",
  PRODUCT_REQUESTED: "/products-requested",
  ADD_PRODUCT: "/add-product",
  EDIT_WAREHOUSE: "/edit-warehouse/:id",
  CREATE_SHIPPING_ORDER: "/add-shipping",
  MANAGE_SHIPPING_ORDER: "/manage-shipping/:id",
  VIEW_SHIPPING_ORDER: "/shipping/:id",
  GENERATE_SHIPPING_ORDER_REQUEST: "/generate-store-order/:id",
  STORE_MANAGER_LIST: "/store-managers",
  STORE_MANAGER_ADD: "/add-store-manager",
  STORE_MANAGER_EDIT: "/edit-store-manager/:id",
  STORE_MANAGER_VIEW: "/store-manager/:id",
  STORE_VIEW: "/franchise/:franchiseId/store/:storeId",
  // VM_TEMPLATE_LIST: "/vm-templates",
  VM_TEMPLATE_LIST: "/templates-vm",
  VM_TEMPLATE_LIST_V2: "/machine-layout-config",
  // VM_TEMPLATE_VIEW: "/vm-template/:id",
  VM_TEMPLATE_VIEW: "/templates-vm/:id",
  VM_TEMPLATE_ADD: "/add-vm-template",
  VM_TEMPLATE_EDIT: "/edit-vm-template/:id",
  VM_TEMPLATE_CLONE: "/clone-vm-template/:id",
  TECH_VM_TEMPLATE_LIST: "/tech-vm-templates",
  TECH_VM_TEMPLATE_VIEW: "/tech-vm-template/:id",
  TECH_VM_TEMPLATE_ADD: "/tech-add-vm-template",
  TECH_VM_TEMPLATE_EDIT: "/tech-edit-vm-template/:id",
  TECH_VM_TEMPLATE_CLONE: "/tech-clone-vm-template/:id",
  VIEW_VM: "/vm/:id",
  TECHNICIAN_VIEW_VM: "/technician-vm/:id",
  PLANOGRAM_TEMPLATE_LIST: "/planogram-templates",
  PLANOGRAM_TEMPLATE_EDIT: "/edit-planogram-template/:id",
  PLANOGRAM_TEMPLATE_CLONE: "/planogram-template-clone/:id",
  PLANOGRAM_TEMPLATE_ADD: "/add-planogram-template",
  PLANOGRAM_TEMPLATE_VIEW: "/view-planogram-template/:id",
  BULK_REFILL_LIST: "/bulk-refills",
  BULK_REFILL_VIEW: "/bulk-refill/:id",
  BULK_REFILL_ADD: "/add-bulk-refill",
  BULK_REFILL_EDIT: "/edit-bulk-refill/:id",
  REFILL_PARTNER_LIST: "/refill-partners",
  REFILL_PARTNER_VIEW: "/refill-partner/:id",
  REFILL_PARTNER_ADD: "/add-refill-partner",
  REFILL_PARTNER_EDIT: "/edit-refill-partner/:id",
  TECHNICIAN_PARTNER_LIST: "/technician-partners",
  TECHNICIAN_PARTNER_ADD: "/add-technician-partner",
  TECHNICIAN_PARTNER_VIEW: "/technician-partner/:id",
  TECHNICIAN_PARTNER_EDIT: "/edit-technician-partner/:id",
  TECHNICIAN_LINK_NEW_WAREHOUSE: "/technician-link-warehouse/:id",
  TECHNICIAN_LINK_NEW_VM: "/technician-link-vm/:id",
  TECHNICIAN_EDIT_LINK_VM: "/technician-edit-link-vm/:id",
  TECHNICIAN_TRANSACTION_LIST: "/tech-transaction_list",
  TECHNICIAN_VM_LIST: "/technician-vm-list",
  TECHNICIAN_LOGS: "/technician-logs",
  MOTOR_ACTION_LOGS: "/motor-action-logs",
  GET_INCIDENT_LIST: "/incident-list",
  INCIDENT_TYPE_ADD: "/add-incident-type",
  ADD_INCIDENT: "/add-incident",
  GET_JOB_LIST: "/job-list",
  ADD_JOB: "/add-job",
  VIEW_JOB: "/job/:id",
  VIEW_DELIVERY_PERSON: "/delivery-person/:id",
  // VM_SETTINGS_LIST: "/vm-settings",
  // VM_SETTINGS_VIEW: "/vm-setting/:id",
  VM_SETTINGS_LIST: "/settings-vm",
  VM_SETTINGS_VIEW: "/setting-vm/:id",
  VM_SETTINGS_ADD: "/add-vm-setting",
  VM_SETTINGS_EDIT: "/edit-vm-setting/:id",
  VM_SETTINGS_CLONE: "/clone-vm-setting/:id",
  NOTIFICATIONS: "/notifications",
  CREATE_STORE_RETURN:
    "/franchise/:franchiseId/store/:storeId/create-store-return",
  REPORT: "/report",
  RETAILERS: "/retailers",
  DISCARDED_BIN_OVERVIEW: "/discarded-bin-overview/:id",
  VIEW_TALLY_ORDER_OVERVIEW: "/view-tally-order/:id",
  VIEW_CASH_ORDER_OVERVIEW: "/view-cash-order/:id",
  ADVERTISEMENT_MANAGEMENT: "/advertisements",
  ADD_ADVERTISEMENT: "/add-advertisement",
  EDIT_ADVERTISEMENT: "/edit-advertisement/:id",
  VIEW_ADVERTISEMENT: "/advertisement/:id",
  VM_ANALYTICS: "/analytics-vm",
  LINKED_NEW_REFILL_PARTNER: "/link-refill-partner/:id",
  EDIT_LINKED_REFILL_PARTNER: "/edit-link-refill-partner/:id",
  LINKED_NEW_WAREHOUSE_MANAGER: "/link-warehouse-manager/:id",
  EDIT_LINKED_WAREHOUSE_MANAGER: "/edit-link-warehouse-manager/:id",
  LINKED_NEW_WAREHOUSE_FOR_WM: "/link-warehouse-wm/:id",
  EDIT_LINKED_WAREHOUSE_FOR_WM: "/edit-link-warehouse-wm/:id",
  THIRD_PARTY_SALES_LIST: "/third-party-sales",
  PLATFORM_LINKED_VM_LIST: "/platform-linked-vms/:id",
  VM_RESTRICTED_PRODUCT_LIST: "/restricted-products/:id",
  LINKED_NEW_VM: "/link-vm/:id",
  EDIT_LINKED_VM: "/edit-link-vm/:id",
  LINKED_NEW_WAREHOUSE: "/link-warehouse/:id",
  EDIT_LINKED_WAREHOUSE: "/edit-link-warehouse/:id",
  LINKED_NEW_VEHICLE: "/link-vehicle/:id",
  EDIT_LINKED_VEHICLE: "/edit-link-vehicle/:id",
  NEGATIVE_ITEMS_LIST: "/negative-items",
  VIEW_NEGATIVE_ITEM: "/negative-item/:id",
  ADD_NEGATIVE_ITEM: "/add-negative-item",
  EDIT_NEGATIVE_ITEM: "/edit-negative-item/:id",
  VIEW_NEGATIVE_ITEM: "/view-negative-item/:id",
  LINKED_NEW_ITEM: "/link-item/:id",
  EDIT_LINK_ITEM: "/edit-link-item/:id",
  LINKED_NEW_VM_NEGATIVE_ITEM: "/link-vm-negative-item/:id",
  EDIT_LINK_VM_NEGATIVE_ITEM: "/edit-vm-negative-item/:id",
  LINK_REFILL_PERMISSION: "/link-refiller-permission/:id",
  EDIT_LINK_REFILL_PERMISSION: "/edit-link-refiller-permission/:id",
  LINK_TECHNICIAN_PERMISSION: "/link-technician-permission/:id",
  EDIT_LINK_TECHNICIAN_PERMISSION: "/edit-link-technician-permission/:id",
  LINK_TECHNICIAN_NOTIFICATIONS: "/link-technician-notifications/:id",
  EDIT_LINK_TECHNICIAN_NOTIFICATIONS: "/edit-link-technician-notifications/:id",
  LINK_REFILL_NOTIFICATIONS: "/link-refiller-notifications/:id",
  EDIT_LINK_REFILL_NOTIFICATIONS: "/edit-link-refiller-notifications/:id",
  CREATE_WAREHOUSE_MANAGER: "/add-wm",
  EDIT_WAREHOUSE_MANAGER: "/edit-wm/:id",
  VIEW_WAREHOUSE_MANAGER: "/wm/:id",
  ADD_REQUEST_PRODUCT: "/add-request-product",
  EDIT_REQUEST_PRODUCT: "/edit-request-product/:id",
  VIEW_REQUEST_PRODUCT: "/request-product/:id",
  CREATE_KIT_TRANSFER: "/add-kit-transfer",
  CREATE_PACKAGE_TRANSFER: "/add-package-transfer",
  VIEW_PACKAGE_TRANSFER: "/package-transfer/:id",
  VIEW_KIT_TRANSFER: "/kit-transfer/:id",
  VIEW_SALE_ORDER: "/sale-order/:id",
  VIEW_CASH_COLLECTION: "/cash-collection/:id",
  VIEW_TOPUP_OVERVIEW: "/view-topup/:id",
  VIEW_TRANSFER_ORDER: "/transfer-order/:id",
  VIEW_REQUEST_ORDER: "/request-order/:id",
  VIEW_SUBOFFER_OVERVIEW: "/suboffer-view/:id",
  VIEW_OFFER_HISTORY_OVERVIEW: "/offer-history-view/:id",
  VIEW_SUBOFFER_HISTORY_OVERVIEW: "/sub-offer-history-view/:id",
  ADD_DISCOUNT: "/add-discount",
  EDIT_DISCOUNT: "/edit-discount/:id",
  CLONE_DISCOUNT: "/clone-discount/:id",
  RESTART_DISCOUNT: "/restart-discount/:id",
  MACHINE_EVENT_LOG: "/machine-event-log",
};
//query string parameters for routes.
//required is field just to let developer know that the parameter is required.
export const ROUTES_QUERY_STRING_PARAMS = {
  // [APP_ROUTES.CONFIGURE_VENDING_MACHINE]: {
  //   franchiseId: { key: "franchiseId", required: false },
  //   vmId: { key: "vmId", required: true },
  // },
  // [APP_ROUTES.RECONFIGURE_VENDING_MACHINE]: {
  //   franchiseId: { key: "franchiseId", required: false },
  //   vmId: { key: "vmId", required: true },
  // },
  [APP_ROUTES.ADD_REFILL_PLAN]: {
    vmId: { key: "vmId", required: true },
    warehouseId: { key: "warehouseId", required: false },
    storeId: { key: "storeId", required: false },
  },
  [APP_ROUTES.EDIT_REFILL_PLAN]: {
    vmId: { key: "vmId", required: true },
    refillPlanId: { key: "refillPlanId", required: true },
    warehouseId: { key: "warehouseId", required: false },
    storeId: { key: "storeId", required: false },
  },
  [APP_ROUTES.LIST_REFILLS]: {
    vmId: { key: "vmId", required: true },
    storeId: { key: "storeId", required: false },
    warehouseId: { key: "warehouseId", required: false },
  },
  [APP_ROUTES.VIEW_REFILL_PLAN]: {
    vmId: { key: "vmId", required: true },
    refillPlanId: { key: "refillPlanId", required: true },
    warehouseId: { key: "warehouseId", required: false },
    storeId: { key: "storeId", required: false },
  },
  [APP_ROUTES.RETURN_ORDER_VIEW]: {
    vmId: { key: "vmId", required: true },
    returnRefillOrderId: { key: "returnRefillOrderId", required: true },
    warehouseId: { key: "warehouseId", required: false },
    storeId: { key: "storeId", required: false },
  },
  [APP_ROUTES.SALES_ANALYTICS]: {
    templateId: { key: "templateId", required: false },
  },

  [APP_ROUTES.BULK_REFILL_EDIT]: {
    bulkRefillId: { key: "bulkRefillId", required: true },
  },

  [APP_ROUTES.VIEW_TOPUP_OVERVIEW]: {
    refillPlanId: { key: "refillPlanId", required: true },
  },
  // [APP_ROUTES.VIEW_SUBOFFER_OVERVIEW]: {
  //   refillPlanId: { key: "refillPlanId", required: true },
  // },
};

//Routes with inline query value. Example : zone/15 , warehouse/15
export const ROUTES_WITH_INLINE_PARAMS = {
  VENDING_MACHINE_MASTER_CONFIG: (id) =>
    APP_ROUTES.VENDING_MACHINE_MASTER_CONFIG.replace(":id", id),
  VIEW_ZONE: (id) => APP_ROUTES.VIEW_ZONE.replace(":id", id),
  VIEW_WAREHOUSE: (id) => APP_ROUTES.VIEW_WAREHOUSE.replace(":id", id),
  EDIT_SUPPLIER: (id) => APP_ROUTES.SUPPLIER_EDIT.replace(":id", id),
  VIEW_SUPPLIER: (id) => APP_ROUTES.SUPPLIER_VIEW.replace(":id", id),
  
  VIEW_JOB: (id) => APP_ROUTES.VIEW_JOB.replace(":id", id),

  SUPPLIER_RETURN_OVERVIEW: (id) =>
    APP_ROUTES.SUPPLIER_RETURN_OVERVIEW.replace(":id", id),
  MATERIAL_TRANSFER_OVERVIEW: (id) =>
    APP_ROUTES.MATERIAL_TRANSFER_OVERVIEW.replace(":id", id),
  MATERIAL_TRANSFER_MANAGE: (id) =>
    APP_ROUTES.MATERIAL_TRANSFER_MANAGE.replace(":id", id),
  MATERIAL_TRANSFER_EDIT: (id) =>
    APP_ROUTES.MATERIAL_TRANSFER_EDIT.replace(":id", id),
  TALLY_INVENTORY_OVERVIEW: (id) =>
    APP_ROUTES.TALLY_INVENTORY_OVERVIEW.replace(":id", id),
  TALLY_INVENTORY_CREATE: (id) =>
    APP_ROUTES.TALLY_INVENTORY_ADD.replace(":id", id),
  VIEW_PRODUCT: (id) => APP_ROUTES.PRODUCT_VIEW.replace(":id", id),
  VIEW_PRODUCT_CATEGORY: (id) =>
    APP_ROUTES.PRODUCT_CATEGORY_VIEW.replace(":id", id),
  EDIT_PURCHASE_ORDER: (id) =>
    APP_ROUTES.PURCHASE_ORDER_EDIT.replace(":id", id),
  EDIT_PURCHASE_RETURN: (id) =>
    APP_ROUTES.PURCHASE_RETURN_EDIT.replace(":id", id),
  SAME_PURCHASE_ORDER: (id) =>
    APP_ROUTES.SAME_PURCHASE_ORDER.replace(":id", id),
  VIEW_PURCHASE_ORDER: (id) =>
    APP_ROUTES.PURCHASE_ORDER_VIEW.replace(":id", id),
  VIEW_PURCHASE_RETURN: (id) =>
    APP_ROUTES.PURCHASE_RETURN_VIEW.replace(":id", id),
  MANAGE_PURCHASE_ORDER: (id) =>
    APP_ROUTES.PURCHASE_ORDER_MANAGE.replace(":id", id),
  GENERATE_SHIPPING_ORDER_REQUEST: (id) =>
    APP_ROUTES.GENERATE_SHIPPING_ORDER_REQUEST.replace(":id", id),
  VIEW_STORE_MANAGER: (id) => APP_ROUTES.STORE_MANAGER_VIEW.replace(":id", id),
  EDIT_STORE_MANAGER: (id) => APP_ROUTES.STORE_MANAGER_EDIT.replace(":id", id),
  VIEW_STORE: (franchiseId, storeId) =>
    APP_ROUTES.STORE_VIEW.replace(":franchiseId", franchiseId).replace(
      ":storeId",
      storeId
    ),
  VIEW_VM_TEMPLATE: (templateId) =>
    APP_ROUTES.VM_TEMPLATE_VIEW.replace(":id", templateId),
  EDIT_VM_TEMPLATE: (templateId) =>
    APP_ROUTES.VM_TEMPLATE_EDIT.replace(":id", templateId),
  CLONE_VM_TEMPLATE: (templateId) =>
    APP_ROUTES.VM_TEMPLATE_CLONE.replace(":id", templateId),
  TECH_CLONE_VM_TEMPLATE: (templateId) =>
    APP_ROUTES.TECH_VM_TEMPLATE_CLONE.replace(":id", templateId),
  TECH_EDIT_VM_TEMPLATE: (templateId) =>
    APP_ROUTES.TECH_VM_TEMPLATE_EDIT.replace(":id", templateId),
  TECH_VIEW_VM_TEMPLATE: (templateId) =>
    APP_ROUTES.TECH_VM_TEMPLATE_VIEW.replace(":id", templateId),
  EDIT_VM: (vmId) => APP_ROUTES.EDIT_VENDING_MACHINE.replace(":id", vmId),
  TECH_EDIT_VM: (vmId) => APP_ROUTES.TECH_EDIT_VENDING_MACHINE.replace(":id", vmId),
  VIEW_VM: (vmId) => APP_ROUTES.VIEW_VM.replace(":id", vmId),
  TECHNICIAN_VIEW_VM: (vmId) => APP_ROUTES.TECHNICIAN_VIEW_VM.replace(":id", vmId),
  EDIT_BULK_REFILL: (bulkRefillId) =>
    APP_ROUTES.BULK_REFILL_EDIT.replace(":id", bulkRefillId),
  VIEW_BULK_REFILL: (bulkRefillId) =>
    APP_ROUTES.BULK_REFILL_VIEW.replace(":id", bulkRefillId),
  VIEW_VM_SETTINGS: (templateId) =>
    APP_ROUTES.VM_SETTINGS_VIEW.replace(":id", templateId),
  EDIT_VM_SETTINGS: (templateId) =>
    APP_ROUTES.VM_SETTINGS_EDIT.replace(":id", templateId),
  CLONE_VM_SETTINGS: (
    templateId // {
  ) =>
    //   title: "Refill Plan",
    //   component: TopUpOverview,
    //   route: APP_ROUTES.VIEW_CASH_ORDER_OVERVIEW,
    //   sidebar: false,
    //   permissions: [],
    // },
    APP_ROUTES.VM_SETTINGS_CLONE.replace(":id", templateId),
  EDIT_PLANOGRAM_TEMPLATE: (templateId) =>
    APP_ROUTES.PLANOGRAM_TEMPLATE_EDIT.replace(":id", templateId),
  CLONE_PLANOGRAM_TEMPLATE: (templateId) =>
    APP_ROUTES.PLANOGRAM_TEMPLATE_CLONE.replace(":id", templateId),
  VIEW_PLANOGRAM_TEMPLATE: (templateId) =>
    APP_ROUTES.PLANOGRAM_TEMPLATE_VIEW.replace(":id", templateId),

  DISCARDED_BIN_OVERVIEW: (id) =>
    APP_ROUTES.DISCARDED_BIN_OVERVIEW.replace(":id", id),

  VIEW_TALLY_ORDER_TEMPLATE: (templateId) =>
    APP_ROUTES.VIEW_TALLY_ORDER_OVERVIEW.replace(":id", templateId),

  VIEW_CASH_ORDER_TEMPLATE: (cashId) =>
    APP_ROUTES.VIEW_CASH_ORDER_OVERVIEW.replace(":id", cashId),

  LINK_NEW_REFILL_PARTNER: (warehouseId) =>
    APP_ROUTES.LINKED_NEW_REFILL_PARTNER.replace(":id", warehouseId),

  EDIT_LINK_REFILL_PARTNER: (warehouseId) =>
    APP_ROUTES.EDIT_LINKED_REFILL_PARTNER.replace(":id", warehouseId),

  TECHNICIAN_LINK_NEW_WAREHOUSE: (warehouseId) =>
    APP_ROUTES.TECHNICIAN_LINK_NEW_WAREHOUSE.replace(":id" , warehouseId),

  TECHNICIAN_LINK_NEW_VM: (technicianId) =>
    APP_ROUTES.TECHNICIAN_LINK_NEW_VM.replace(":id", technicianId),

  TECHNICIAN_EDIT_LINK_VM: (technicianId) =>
    APP_ROUTES.TECHNICIAN_EDIT_LINK_VM.replace(":id", technicianId),

  EDIT_TECHNICIAN: (technicianId) => 
    APP_ROUTES.TECHNICIAN_PARTNER_EDIT.replace(":id" , technicianId),

  LINK_NEW_WAREHOUSE_MANAGER: (warehouseId) =>
    APP_ROUTES.LINKED_NEW_WAREHOUSE_MANAGER.replace(":id", warehouseId),

  EDIT_LINK_WAREHOUSE_MANAGER: (warehouseId) =>
    APP_ROUTES.EDIT_LINKED_WAREHOUSE_MANAGER.replace(":id", warehouseId),

  LINK_NEW_WAREHOUSE_FOR_WM: (warehouseManagerId) =>
    APP_ROUTES.LINKED_NEW_WAREHOUSE_FOR_WM.replace(":id", warehouseManagerId),

  EDIT_LINK_WAREHOUSE_FOR_WM: (warehouseManagerId) =>
    APP_ROUTES.EDIT_LINKED_WAREHOUSE_FOR_WM.replace(":id", warehouseManagerId),

  LINK_NEW_VM: (refillPartnerId) =>
    APP_ROUTES.LINKED_NEW_VM.replace(":id", refillPartnerId),

  EDIT_LINK_VM: (refillPartnerId) =>
    APP_ROUTES.EDIT_LINKED_VM.replace(":id", refillPartnerId),

  VIEW_REFILL_PARTNER: (refillPartnerId) =>
    APP_ROUTES.REFILL_PARTNER_VIEW.replace(":id", refillPartnerId),

  VIEW_TECHNICIAN_PARTNER: (technicianPartnerId) =>
    APP_ROUTES.TECHNICIAN_PARTNER_VIEW.replace(":id", technicianPartnerId),

  LINK_NEW_WAREHOUSE: (refillPartnerId) =>
    APP_ROUTES.LINKED_NEW_WAREHOUSE.replace(":id", refillPartnerId),


  LINK_NEW_WAREHOUSE: (refillPartnerId) =>
    APP_ROUTES.LINKED_NEW_WAREHOUSE.replace(":id", refillPartnerId),

  EDIT_LINK_WAREHOUSE: (refillPartnerId) =>
    APP_ROUTES.EDIT_LINKED_WAREHOUSE.replace(":id", refillPartnerId),

  LINK_NEW_VEHICLE: (refillPartnerId) =>
    APP_ROUTES.LINKED_NEW_VEHICLE.replace(":id", refillPartnerId),

  EDIT_LINK_VEHICLE: (refillPartnerId) =>
    APP_ROUTES.EDIT_LINKED_VEHICLE.replace(":id", refillPartnerId),

  EDIT_NEGATIVE_ITEM: (negativeItemId) =>
    APP_ROUTES.EDIT_NEGATIVE_ITEM.replace(":id", negativeItemId),

  VIEW_NEGATIVE_ITEM: (negativeItemId) =>
    APP_ROUTES.VIEW_NEGATIVE_ITEM.replace(":id", negativeItemId),

  LINK_NEW_ITEM: (negativeItemId) =>
    APP_ROUTES.LINKED_NEW_ITEM.replace(":id", negativeItemId),

  EDIT_LINK_ITEM: (negativeItemId) =>
    APP_ROUTES.EDIT_LINK_ITEM.replace(":id", negativeItemId),

  LINK_NEW_VM_NEGATIVE_ITEM: (negativeItemId) =>
    APP_ROUTES.LINKED_NEW_VM_NEGATIVE_ITEM.replace(":id", negativeItemId),

  EDIT_LINK_VM_NEGATIVE_ITEM: (negativeItemId) =>
    APP_ROUTES.EDIT_LINK_VM_NEGATIVE_ITEM.replace(":id", negativeItemId),

  LINK_NEW_REFILL_PERMISSION: (warehouseId) =>
    APP_ROUTES.LINK_REFILL_PERMISSION.replace(":id", warehouseId),

  EDIT_LINK_REFILL_PERMISSION: (warehouseId) =>
    APP_ROUTES.EDIT_LINK_REFILL_PERMISSION.replace(":id", warehouseId),

  LINK_NEW_TECHNICIAN_PERMISSION: (warehouseId) =>
    APP_ROUTES.LINK_TECHNICIAN_PERMISSION.replace(":id", warehouseId),

  EDIT_LINK_TECHNICIAN_PERMISSION: (warehouseId) =>
    APP_ROUTES.EDIT_LINK_TECHNICIAN_PERMISSION.replace(":id", warehouseId),

  LINK_NEW_TECHNICIAN_NOTIFICATIONS: (warehouseId) =>
    APP_ROUTES.LINK_TECHNICIAN_NOTIFICATIONS.replace(":id", warehouseId),

  EDIT_LINK_TECHNICIAN_NOTIFICATIONS: (warehouseId) =>
    APP_ROUTES.EDIT_LINK_TECHNICIAN_NOTIFICATIONS.replace(":id", warehouseId),

  LINK_NEW_REFILL_NOTIFICATIONS: (warehouseId) =>
    APP_ROUTES.LINK_REFILL_NOTIFICATIONS.replace(":id", warehouseId),

  EDIT_LINK_REFILL_NOTIFICATIONS: (warehouseId) =>
    APP_ROUTES.EDIT_LINK_REFILL_NOTIFICATIONS.replace(":id", warehouseId),

  EDIT_PRODUCT_REQUEST: (requestProductId) =>
    APP_ROUTES.EDIT_REQUEST_PRODUCT.replace(":id", requestProductId),

  VIEW_PRODUCT_REQUEST: (requestProductId) =>
    APP_ROUTES.VIEW_REQUEST_PRODUCT.replace(":id", requestProductId),

  VIEW_PACKAGE_TRANSFER: (warehouseId) =>
    APP_ROUTES.VIEW_PACKAGE_TRANSFER.replace(":id", warehouseId),

  VIEW_KIT_TRANSFER: (warehouseId) =>
    APP_ROUTES.VIEW_KIT_TRANSFER.replace(":id", warehouseId),

  EDIT_WAREHOUSE_MANAGER: (userId) =>
    APP_ROUTES.EDIT_WAREHOUSE_MANAGER.replace(":id", userId),

  VIEW_WAREHOUSE_MANAGER: (userId) =>
    APP_ROUTES.VIEW_WAREHOUSE_MANAGER.replace(":id", userId),

  VIEW_SALE_ORDER: (id) => APP_ROUTES.VIEW_SALE_ORDER.replace(":id", id),

  VIEW_CASH_COLLECTION: (id) =>
    APP_ROUTES.VIEW_CASH_COLLECTION.replace(":id", id),

  VIEW_TRANSFER_ORDER: (id) =>
    APP_ROUTES.VIEW_TRANSFER_ORDER.replace(":id", id),

  VIEW_REQUEST_ORDER: (id) => APP_ROUTES.VIEW_REQUEST_ORDER.replace(":id", id),
  VIEW_TOPUP_OVERVIEW: (id) =>
    APP_ROUTES.VIEW_TOPUP_OVERVIEW.replace(":id", id),
  VIEW_SUBOFFER_OVERVIEW: (id) =>
    APP_ROUTES.VIEW_SUBOFFER_OVERVIEW.replace(":id", id),
  VIEW_OFFER_HISTORY_OVERVIEW: (id) =>
    APP_ROUTES.VIEW_OFFER_HISTORY_OVERVIEW.replace(":id", id),
  VIEW_SUBOFFER_HISTORY_OVERVIEW: (id) =>
    APP_ROUTES.VIEW_SUBOFFER_HISTORY_OVERVIEW.replace(":id", id),
};

/*
Functions that return query string urls
.
.
*/

//Refills list page
export function refillsListUrl() {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].vmId.key]: this.vmId,
  };

  if (this.storeId) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.LIST_REFILLS, queryParams);
}
//Refills list page with preselected FIlters
export function refillsListPreSelectedFiltersUrl() {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].vmId.key]: this.vmId,
  };

  if (this.storeId) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].warehouseId.key
    ] = this.warehouseId;
  }
  return getRouteWithQueryString(
    APP_ROUTES.LIST_REFILLS,
    queryParams,
    this.filters
  );
}

export function refillsListReturnOrderUrl(vmId, storeId, warehouseId) {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].vmId.key]: vmId,
  };

  if (storeId) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].storeId.key
    ] = storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.LIST_REFILLS].warehouseId.key
    ] = warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.LIST_REFILLS, queryParams);
}

//view Refill Plan from Refill List
export function viewRefillUrl(vmId, id) {
  //Query string parameters for url

  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].vmId.key]: vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].refillPlanId.key]:
      id,
  };
  // if (this.storeId) {
  //   queryParams[
  //     ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].storeId.key
  //   ] = this.storeId;
  // } else {
  //   queryParams[
  //     ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].warehouseId.key
  //   ] = this.warehouseId;
  // }

  return getFullRouteWithQueryString(APP_ROUTES.VIEW_REFILL_PLAN, queryParams);
}

//View Refill Page
export function viewRefillPlanUrl(id) {
  //Query string parameters for url

  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].vmId.key]:
      this.vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].refillPlanId.key]:
      id,
  };
  if (this.storeId) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_REFILL_PLAN].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.VIEW_REFILL_PLAN, queryParams);
}

export function viewTopUpUrl(id) {
  //Query string parameters for url

  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.VIEW_TOPUP_OVERVIEW].refillPlanId
      .key]: id,
  };

  return getFullRouteWithQueryString(
    APP_ROUTES.VIEW_TOPUP_OVERVIEW,
    queryParams
  );
}

//View Refill Page
export function viewReturnRefillOrderUrl(id) {
  //Query string parameters for url

  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW].vmId.key]:
      this.vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW]
      .returnRefillOrderId.key]: id,
  };

  if (this.storeId) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.RETURN_ORDER_VIEW, queryParams);
}

//view return order refill page directly from refill plan list
export function viewReturnRefillUrl(vmId, id) {
  //Query string parameters for url

  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW].vmId.key]: vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW]
      .returnRefillOrderId.key]: id,
  };

  // if (this.storeId) {
  //   queryParams[
  //     ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW].storeId.key
  //   ] = this.storeId;
  // } else {
  //   queryParams[
  //     ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RETURN_ORDER_VIEW].warehouseId.key
  //   ] = this.warehouseId;
  // }

  return getFullRouteWithQueryString(APP_ROUTES.RETURN_ORDER_VIEW, queryParams);
}

//Add new refill page
export function addNewRefillUrl() {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.ADD_REFILL_PLAN].vmId.key]:
      this.vmId,
  };

  if (this.storeToVMapplicable) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.ADD_REFILL_PLAN].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.ADD_REFILL_PLAN].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.ADD_REFILL_PLAN, queryParams);
}

// edit refill plan directly from refill list page
export function editRefillPlan(vmId, refillId) {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].vmId.key]: vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].refillPlanId.key]:
      refillId,
  };

  // if (this.storeToVMapplicable) {
  //   queryParams[
  //     ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].storeId.key
  //   ] = this.storeId;
  // } else {
  //   queryParams[
  //     ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].warehouseId.key
  //   ] = this.warehouseId;
  // }

  return getFullRouteWithQueryString(APP_ROUTES.EDIT_REFILL_PLAN, queryParams);
}

//Edit Refill page
export function editRefillUrl(refillId) {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].vmId.key]:
      this.vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].refillPlanId.key]:
      refillId,
  };

  if (this.storeToVMapplicable) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.EDIT_REFILL_PLAN].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.EDIT_REFILL_PLAN, queryParams);
}

//Add new refill page
export function addNewBulkRefillUrl() {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_ADD].vmId.key]:
      this.vmId,
  };

  if (this.storeToVMapplicable) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_ADD].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_ADD].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.BULK_REFILL_ADD, queryParams);
}

//Edit Refill page
export function editBulkRefillUrl(refillId) {
  //Query string parameters for url
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_EDIT].vmId.key]:
      this.vmId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_EDIT].refillPlanId.key]:
      refillId,
  };

  if (this.storeToVMapplicable) {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_EDIT].storeId.key
    ] = this.storeId;
  } else {
    queryParams[
      ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.BULK_REFILL_EDIT].warehouseId.key
    ] = this.warehouseId;
  }

  return getFullRouteWithQueryString(APP_ROUTES.BULK_REFILL_EDIT, queryParams);
}

//Configure vending machine page
export function configureVendingMachineUrl(franchiseId, vmId) {
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.CONFIGURE_VENDING_MACHINE]
      .franchiseId.key]: franchiseId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.CONFIGURE_VENDING_MACHINE].vmId.key]:
      vmId,
  };

  return getFullRouteWithQueryString(
    APP_ROUTES.CONFIGURE_VENDING_MACHINE,
    queryParams
  );
}

//Re-configure vending machine page
export function reConfigureVendingMachineUrl(franchiseId, vmId) {
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RECONFIGURE_VENDING_MACHINE]
      .franchiseId.key]: franchiseId,
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.RECONFIGURE_VENDING_MACHINE].vmId
      .key]: vmId,
  };

  return getFullRouteWithQueryString(
    APP_ROUTES.RECONFIGURE_VENDING_MACHINE,
    queryParams
  );
}

//Saved sales template url.
export function savedSalesAnalyticsUrl(id) {
  let queryParams = {
    [ROUTES_QUERY_STRING_PARAMS[APP_ROUTES.SALES_ANALYTICS].templateId.key]: id,
  };

  return getFullRouteWithQueryString(APP_ROUTES.SALES_ANALYTICS, queryParams);
}
